export enum SENDER {
    user = 'user',
    agent = 'agent',
}
